import { Checkbox, Button, FormControlLabel, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import { AlertInfo } from "components/demandaEnLineaComponents/alertInfo";
import { useEncuestaCalidad } from "hooks/encuestas/encuestaCalidad";
import { Preguntas } from "interfaces/authInterface";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/store";

interface ResponseRecord {
  idPregunta: number;
  idRespuesta: number;
  idAskPadre?: number;
}

export const ModalContentEncuesta = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const {
    preguntas,
    datosEncuesta,
    preguntasHijas,
    getPreguntas,
    getAskHijas,
    startGetPreguntas,
    startPostEncuesta,
  } = useEncuestaCalidad();
  const { user } = useSelector((state: RootState) => state.auth);
  const [selectedRes, setSelectedRes] = useState<ResponseRecord[]>([]);
  const [indexHijas, setIndexHijas] = useState(0);

 
  const PENULTIMATE_QUESTION_ID = preguntas[preguntas.length - 2]?.idPregunta;
  const NO_ANSWER_ID = 182; 
  const isPenultimateQuestion = currentIndex === preguntas.length - 2;
  const isLastQuestion = currentIndex === preguntas.length - 1;
  const penultimateQuestionResponse = selectedRes.find(
    res => res.idPregunta === PENULTIMATE_QUESTION_ID
  );
  const shouldFinalizeAtPenultimate = 
    isPenultimateQuestion && 
    penultimateQuestionResponse?.idRespuesta === NO_ANSWER_ID;

  const handleNext = () => {
    if (shouldFinalizeAtPenultimate) {
      handleFinal();
    } else if (currentIndex < preguntas.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleFinal = () => {
    const envioQ = {
      idPersonaAutorizada: user?.session?.cveUsuario,
      idEncuesta: 6,
      respuestas: selectedRes,
    };
    startPostEncuesta(envioQ);
  };

  const handleChange = (
    idPregunta: number,
    idRespuesta: number,
    despliega: string,
    idAskPadre: number
  ) => {
    setSelectedRes((prevState) => {
      const existingIndex = prevState.findIndex(
        (res) => res.idPregunta === idPregunta
      );

      const existingSamePadreIndex = idAskPadre
        ? prevState.findIndex(
            (res) =>
              res.idAskPadre !== undefined && res.idAskPadre === idAskPadre
          )
        : -1;

      const padreExiste = idAskPadre
        ? prevState.some((res) => res.idPregunta === idAskPadre)
        : true; 

      if (!padreExiste) {
        return prevState.filter((res) => res.idPregunta !== idPregunta);
      }

      if (existingIndex !== -1) {
        if (idPregunta === 8) {
          const existingResp = prevState.find(
            (res) => res.idRespuesta === idRespuesta
          );

          if (existingResp) {
            const quitarRes = prevState.filter(
              (res) => res.idRespuesta !== idRespuesta
            );
            return [...quitarRes];
          } else {
            const filteredState = idAskPadre
              ? prevState.filter(
                  (res) =>
                    res.idAskPadre === undefined ||
                    res.idAskPadre !== idAskPadre
                )
              : [...prevState];

            return [...filteredState, { idPregunta, idRespuesta, idAskPadre }];
          }
        } else {
          const updatedState = [...prevState];
          updatedState[existingIndex] = { idPregunta, idRespuesta, idAskPadre };
          return updatedState;
        }
      } else {
        if (existingSamePadreIndex !== -1) {
          const updatedState = [...prevState];
          updatedState[existingSamePadreIndex] = {
            idPregunta,
            idRespuesta,
            idAskPadre,
          };
          return updatedState;
        } else {
          return padreExiste
            ? [...prevState, { idPregunta, idRespuesta, idAskPadre }]
            : prevState;
        }
      }
    });

    if (despliega === "S") {
      if (idPregunta === 12) {
        if (idRespuesta === 44 && preguntasHijas?.length !== 0) {
          const preguntasAntesDe12 = preguntas.filter(
            (p) => p.idPregunta <= 12
          );
          const preguntasDespuesDe12 = preguntas.filter(
            (p) => p.idPregunta > 12
          );
          getPreguntas([
            ...preguntasAntesDe12,
            ...preguntasHijas,
            ...preguntasDespuesDe12,
          ]);
          setCurrentIndex(currentIndex + 1);
        }
      }

      if (
        Number(preguntas[currentIndex]?.cveSeccion) === 998 &&
        preguntas[currentIndex]?.respuestas?.[1]?.idRespuesta === idRespuesta
      ) {
        setIndexHijas(1);
      } else {
        setIndexHijas(0);
      }

      startGetPreguntas(idPregunta);
    } else if (despliega === "N") {
      const hijasRelacionadas = preguntasHijas?.filter(
        (hija) => hija.idPreguntaPadre === idPregunta
      );

      if (hijasRelacionadas?.length) {
        setSelectedRes((prevState) =>
          prevState.filter(
            (res) =>
              !hijasRelacionadas.some(
                (hija) => hija.idPregunta === res.idPregunta
              )
          )
        );
      }

      if (idRespuesta === 45 && preguntas?.length === 8) {
        setSelectedRes((prevState) => {
          const quitarRes = prevState.filter((res) => res.idRespuesta <= 45);
          return [...quitarRes];
        });
        getAskHijas([]);
      } else if (!idAskPadre) {
        getAskHijas([]);
      }
    }
  };

  const allQuestionsAnswered = preguntas.every((pregunta) =>
    selectedRes.some((res) => res?.idPregunta === pregunta?.idPregunta)
  );

  const allQuestionsHijas =
    indexHijas === 0
      ? Number(preguntas[currentIndex]?.cveSeccion) === 998
        ? selectedRes.some(
            (res) => res?.idPregunta === preguntasHijas?.[0]?.idPregunta
          )
        : preguntasHijas.every((pregunta) =>
            selectedRes.some((res) => res?.idPregunta === pregunta?.idPregunta)
          )
      : Number(preguntas[currentIndex]?.cveSeccion) !== 998
      ? preguntasHijas.every((pregunta) =>
          selectedRes.some((res) => res?.idPregunta === pregunta?.idPregunta)
        )
      : selectedRes.some(
          (res) => res?.idPregunta === preguntasHijas?.[1]?.idPregunta
        );

  const questionAnswered = selectedRes.some(
    (res) => res?.idPregunta === preguntas[currentIndex]?.idPregunta
  );

  return (
    <>
      {currentIndex === 0 ? (
        <div>
          <AlertInfo
            title={"Objetivo: " + `${datosEncuesta?.objetivoEncuesta}`}
            subtitle={
              "Nota: Una vez que presione 'Siguiente', no podrá regresar a esta pregunta."
            }
          />
        </div>
      ) : (
        <div>
          <AlertInfo
            title=""
            subtitle={
              "Nota: Una vez que presione 'Siguiente', no podrá regresar a esta pregunta."
            }
          />
        </div>
      )}
      <div>
        {preguntas.length > 0 ? (
          <>
            <div key={preguntas[currentIndex].idPregunta}>
              <div style={{ marginLeft: "15%" }}>
                <Typography>{preguntas[currentIndex].pregunta}</Typography>
              </div>
              {preguntas[currentIndex].respuestas.length > 0 ? (
                preguntas[currentIndex].respuestas.map((respuesta) => (
                  <div style={{ marginLeft: "30%" }}>
                    <FormControlLabel
                      key={respuesta.idRespuesta}
                      control={
                        <Checkbox
                          checked={selectedRes.some(
                            (res) =>
                              res.idPregunta ===
                                preguntas[currentIndex].idPregunta &&
                              res.idRespuesta === respuesta.idRespuesta
                          )}
                          onChange={() =>
                            handleChange(
                              preguntas[currentIndex].idPregunta,
                              respuesta.idRespuesta,
                              respuesta.despliega,
                              preguntas[currentIndex].idPreguntaPadre
                            )
                          }
                        />
                      }
                      label={respuesta.descripcion}
                    />
                  </div>
                ))
              ) : (
                <Typography>Sin respuestas</Typography>
              )}

              {preguntasHijas?.length &&
              preguntas[currentIndex]?.idPregunta ===
                preguntasHijas?.[indexHijas]?.idPreguntaPadre ? (
                <>
                  <div style={{ marginLeft: "15%" }}>
                    <Typography>
                      {preguntasHijas?.[indexHijas]?.pregunta}
                    </Typography>
                  </div>

                  {preguntasHijas?.[indexHijas]?.respuestas?.length > 0 ? (
                    preguntasHijas?.[indexHijas]?.respuestas?.map(
                      (respuesta) => (
                        <div style={{ marginLeft: "30%" }}>
                          <FormControlLabel
                            key={respuesta?.idRespuesta}
                            control={
                              <Checkbox
                                checked={selectedRes.some(
                                  (res) =>
                                    res.idPregunta ===
                                      preguntasHijas?.[indexHijas]
                                        ?.idPregunta &&
                                    res.idRespuesta === respuesta?.idRespuesta
                                )}
                                onChange={() =>
                                  handleChange(
                                    preguntasHijas?.[indexHijas]?.idPregunta,
                                    respuesta?.idRespuesta,
                                    respuesta?.despliega,
                                    preguntasHijas?.[indexHijas]
                                      ?.idPreguntaPadre
                                  )
                                }
                              />
                            }
                            label={respuesta.descripcion}
                          />
                        </div>
                      )
                    )
                  ) : (
                    <Typography>Sin respuestas</Typography>
                  )}
                </>
              ) : null}
            </div>
            <Grid container spacing={18}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}></Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                {!isLastQuestion ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    disabled={
                      (isPenultimateQuestion && !penultimateQuestionResponse) ||
                      (!questionAnswered || !allQuestionsHijas)
                    }
                  >
                    {shouldFinalizeAtPenultimate ? 'Finalizar' : 'Siguiente'}
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleFinal}
                    disabled={
                      !allQuestionsAnswered || !allQuestionsHijas
                    }
                  >
                    Finalizar
                  </Button>
                )}
              </Grid>
            </Grid>
          </>
        ) : (
          <Typography>No hay preguntas disponibles.</Typography>
        )}
      </div>
    </>
  );
};